import { formatDayOfYear } from '~/constants';
import { BillingDayOfMonthModel, serviceBillingModel, serviceModel } from '~/models';
import { RecurrencePeriodTypes } from '~/models/service-billing';
const autoBillingCycleMap = {
    [RecurrencePeriodTypes.Weekly]: 'each week',
    [RecurrencePeriodTypes.BiWeekly]: 'every two weeks',
    [RecurrencePeriodTypes.Monthly]: 'each month',
    [RecurrencePeriodTypes.Quarterly]: 'each quarter',
    [RecurrencePeriodTypes.Yearly]: 'each year'
};
const dayOfMonthBullet = (dayOfMonth, recurrencePeriod)=>{
    const normalized = BillingDayOfMonthModel.make(dayOfMonth);
    const isQuarter = recurrencePeriod === RecurrencePeriodTypes.Quarterly;
    return {
        text: "Billed on the ".concat(normalized.formatDay()).concat(isQuarter || normalized.isLast() ? ' day' : '', " of ").concat(autoBillingCycleMap[recurrencePeriod])
    };
};
export const autoBillingPeriodLabel = (billing)=>{
    const billingDayOfWeek = serviceBillingModel.billingDayOfWeek(billing);
    const billingDayOfMonth = serviceBillingModel.billingDayOfMonth(billing);
    const billingDayOfYear = serviceBillingModel.billingDayOfYear(billing);
    const recurrencePeriod = serviceBillingModel.isOngoing(billing) && serviceModel.recurrencePeriod(billing);
    if (recurrencePeriod === RecurrencePeriodTypes.Weekly && billingDayOfWeek) {
        return {
            text: "Billed every ".concat(billingDayOfWeek)
        };
    } else if (recurrencePeriod === RecurrencePeriodTypes.BiWeekly && billingDayOfWeek) {
        return {
            text: "Billed every other ".concat(billingDayOfWeek)
        };
    } else if (recurrencePeriod === RecurrencePeriodTypes.Monthly && billingDayOfMonth) {
        return dayOfMonthBullet(billingDayOfMonth, recurrencePeriod);
    } else if (recurrencePeriod === RecurrencePeriodTypes.Quarterly) {
        return dayOfMonthBullet(serviceBillingModel.isBilledUpfront(billing) ? 1 : 'last', recurrencePeriod);
    } else if (recurrencePeriod === RecurrencePeriodTypes.Yearly && billingDayOfYear) {
        return {
            text: "Billed on ".concat(formatDayOfYear(billingDayOfYear), " each year")
        };
    } else {
        return null;
    }
};
